<template>
  <v-list-item
    :key="title"
    class="mt-2"
    link
    @click="routeTo(route)"
    v-if="shouldDisplay"
  >
    <v-list-item-icon>
      <v-icon :color="isActive ? 'primary' : ''">{{ icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <div
        class="display-1 font-weight-light"
        :class="isActive ? 'primary--text' : ''"
      >
        {{ title }}
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: ["title", "icon", "route", "display_getter"],
  name: "NavItem",
  computed: {
    isActive() {
      return this.$route.name === this.route;
    },
    shouldDisplay() {
      if (this.display_getter) {
        return this.$store.getters[this.display_getter];
      }
      return true;
    }
  },
  methods: {
    routeTo(routeName) {
      if (this.$vuetify.breakpoint.smAndDown)
        this.$store.commit("viewstate/openNavigation");

      this.$router.push({ name: routeName });
    }
  }
};
</script>

<style scoped></style>
